import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-organism',
  templateUrl: './user-organism.component.html',
  styleUrls: ['./user-organism.component.scss']
})
export class UserOrganismComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
